import * as React from 'react';
import { jsx } from 'react/jsx-runtime';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8 27.38c10.56 0 16.34-8.76 16.34-16.34v-.74a11.78 11.78 0 002.87-3 11.41 11.41 0 01-3.31.9A5.75 5.75 0 0029.23 5a11.47 11.47 0 01-3.66 1.39 5.74 5.74 0 00-9.93 3.93 6.43 6.43 0 00.14 1.32 16.34 16.34 0 01-11.84-6 5.77 5.77 0 001.78 7.67 5.83 5.83 0 01-2.6-.71v.08a5.75 5.75 0 004.61 5.63 5.47 5.47 0 01-1.52.2 5.32 5.32 0 01-1.07-.1 5.73 5.73 0 005.36 4 11.48 11.48 0 01-7.13 2.49A12.44 12.44 0 012 24.82a16.37 16.37 0 008.8 2.56",
    fill: "#0093d1"
  })));
}

function SocialTwitter() {
  return /*#__PURE__*/jsx(SvgSocialTwitter, {});
}

export { SocialTwitter as default };
